import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { ParliamentChart } from './parliamentChart'
import { ParliamentTable } from './parliamentTable'
import './style.scss'
import {
  SeatsPerParty,
  JSONFileSeatDistribution
} from 'types/gemeindeRatSitzeFile'
import { Header } from 'components/header'

export default function index(): ReactElement {
  const [data, setData] = useState<JSONFileSeatDistribution | null>()
  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/erneuerungswahlen-zh-2022/gemeinderat-sitze.json'
    ).then(res =>
      res.json().then(data => {
        setData(data)
      })
    )
  }, [])

  return (
    <>
      {data && (
        <>
          <Header
            title={data.meta.title}
            description={data.meta.description}
            doneMunicipalCouncil={data.meta.doneMunicipalCouncil}
            countStatus={data.meta.countStatus}
          />
          <ParliamentChart
            seatColorArray={data.seatsPerParty.map(row => {
              return { seats: row.seats, color: row.color }
            })}
          />
          <ParliamentTable seatsPerParty={data.seatsPerParty} />
        </>
      )}
    </>
  )
}
